import { PlanoRefeicaoOpcao } from "./PlanoRefeicaoOpcao";

export class PlanoRefeicao {
  idRefeicao?: number;
  nome!: string;
  nomePersonalizado?: string;
  horario!: string;
  sugestoesViaApp?: string[];
  consumoAguaMl?: number;
  observacoes?: string;
  opcoes?: PlanoRefeicaoOpcao[];
}
